// import React, { useState } from "react";
import "./Login.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Login() {
  const [employee, setemployee] = useState({
    empid: "",
    password: "",
  });
  const [Credienticals, setCredienticals] = useState({});

  const navigate = useNavigate();

  const validateLogin = async (event) => {
    event.preventDefault();
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/auth.php`;
    const formData = new FormData();
    try {
      const formData = new FormData();
      formData.append("emp_id", employee?.empid);
      formData.append("password", employee?.password);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      setCredienticals(data);
      if (data.message === "Login successful") {
        setemployee({
          empid: "",
          password: "",
        });
        const userDetails = {
          id: data.id,
          empid: data.emp_id,
          empname: data.emp_name,
          role: data.role,
        };
        localStorage.setItem("userdetails", JSON.stringify(userDetails));
        navigate("/ad");
        // if (data.role === "employee") {
        // } else if (data.role !== "employee") {
        //   navigate("/ad");
        // } else {
        // }
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  useEffect(() => {
    console.log(Credienticals);
  }, [Credienticals]);

  return (
    <div className="wrapper">
      <div className="lohead">
        <>
          {/* <form onSubmit={validateLogin} className="loginform">
          <p>Login</p>
          <div className="group">
            <input
              value={employee?.empid}
              onChange={(e) =>
                setemployee((prev) => ({ ...prev, empid: e.target.value }))
              }
              required
              className="main-input"
              type="text"
            />
            <span className="highlight-span" />
            <label className="lebal-email">Employee ID</label>
          </div>
          <div className="container-1">
            <div className="group">
              <input
                value={employee?.password}
                onChange={(e) =>
                  setemployee((prev) => ({ ...prev, password: e.target.value }))
                }
                required
                className="main-input"
                type="password"
              />
              <span className="highlight-span" />
              <label className="lebal-email">Password</label>
            </div>
          </div>
          <h6 style={{ textAlign: "right", marginTop: "10px" }}>
            Forgot Password?{" "}
            <a href="/resetpassword" className="forgot-link">
              Click Here
            </a>
          </h6>
          <button className="submit">submit</button>
        </form> */}
        </>
        <div className="container12">
          <div className="drop">
            <div className="content">
              <h2 className="animate__heartBeat">Login</h2>
              <form onSubmit={validateLogin}>
                <div className="input-box12">
                  <input
                    value={employee?.empid}
                    onChange={(e) =>
                      setemployee((prev) => ({
                        ...prev,
                        empid: e.target.value,
                      }))
                    }
                    required
                    type="text"
                    name="username"
                    placeholder="Username"
                  />
                </div>
                <div className="input-box12">
                  <input
                    value={employee?.password}
                    onChange={(e) =>
                      setemployee((prev) => ({
                        ...prev,
                        password: e.target.value,
                      }))
                    }
                    required
                    type="password"
                    name="password"
                    placeholder="Password"
                  />
                </div>
                <div className="input-box12">
                  <input type="submit" value="Login" />
                </div>
              </form>
            </div>
            <div>
              <a href="/resetpassword" className="btn12">
                Forgot Password
              </a>
              {/* <a href="#" className="btn12 signup">
                Signup
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
